import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import {
  DEFAULT_SITE_CONTENT,
  SettingsContent,
  SiteContentService,
} from '../../../core/services/site-content.service';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnInit, OnDestroy {
  isSaving = false;
  successMessage = '';
  errorMessage = '';

  readonly settingsForm = this.fb.group({
    siteName: [DEFAULT_SITE_CONTENT.settings.siteName],
    adminEmailDisplay: [DEFAULT_SITE_CONTENT.settings.adminEmailDisplay],
    defaultProductImageUrl: [DEFAULT_SITE_CONTENT.settings.defaultProductImageUrl],
    maintenanceMode: [DEFAULT_SITE_CONTENT.settings.maintenanceMode as boolean],
  });

  private settingsSubscription?: Subscription;

  constructor(
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly fb: FormBuilder,
    private readonly siteContentService: SiteContentService,
  ) {}

  ngOnInit(): void {
    this.settingsSubscription = this.siteContentService.getSection<SettingsContent>('settings').subscribe((settings) => {
      if (settings) {
        this.settingsForm.patchValue(settings);
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  ngOnDestroy(): void {
    this.settingsSubscription?.unsubscribe();
  }

  async saveSettings(): Promise<void> {
    this.isSaving = true;
    this.successMessage = '';
    this.errorMessage = '';

    try {
      await this.siteContentService.updateSection('settings', this.settingsForm.getRawValue());
      this.successMessage = 'Settings saved.';
    } catch (error) {
      this.errorMessage = error instanceof Error && error.message ? error.message : 'Unable to save settings.';
    } finally {
      this.isSaving = false;
      this.changeDetectorRef.detectChanges();
    }
  }
}
